const pgcetmcaMathematics = [
  {
    id: 1,
    question: `If (a - b)³ = a³ - 3a²b + 3ab² - b³ and (a - b + c)² = a² + b² + c² - 2ab - 2bc + 2ca, which of the statements is/are true?
      (i) Both are correct
      (ii) Only the first is correct
      (iii) Only the second is correct
      (iv) Both are incorrect`,
    options: ["A. Only (i)", "B. Only (ii)", "C. Only (iii)", "D. Only (iv)"],
    answer: "A"
  },
  {
    id: 2,
    question: "A person has 2 parents, 4 grandparents, 8 great grandparents and so on. What is the total number of his ancestors during the 6 preceding generations (excluding himself)?",
    options: ["A. 62", "B. 126", "C. 64", "D. 128"],
    answer: "B"
  },
  {
    id: 3,
    question: "If A = [[2,0,1],[1,3,-1],[0,2,1]], the value of the determinant of A is",
    options: ["A. 12", "B. 14", "C. 10", "D. 16"],
    answer: "A"
  },
  {
    id: 4,
    question: `Match List-I with List-II.
      List-I: (a) 1/(1-x²)  (b) 1/(1+x)²  (c) e^x  (d) ln(1+x)
      List-II: (i) 1 - 2x + 3x² - ...  (ii) x - x²/2 + x³/3 - ...  (iii) 1 + x² + x⁴ + ...  (iv) 1 + x + x²/2! + ...`,
    options: ["A. a-iii, b-i, c-iv, d-ii", "B. a-i, b-ii, c-iii, d-iv", "C. a-iii, b-iv, c-i, d-ii", "D. a-ii, b-i, c-iv, d-iii"],
    answer: "A"
  },
  {
    id: 5,
    question: "The number of four-digit numbers that can be formed using 1, 2, 3, 4, 5 without repetition is",
    options: ["A. 625", "B. 120", "C. 24", "D. 20"],
    answer: "B"
  },
{
  id: 6,
  question: "The cost of 3 pens and 2 pencils is Rs. 32 and the cost of 2 pens and 3 pencils is Rs. 28. The cost of each pen in Rs. is",
  options: ["A. 6", "B. 7", "C. 8", "D. 9"],
  answer: "C"
},
  {
    id: 7,
    question: "The equation of the line passing through the points (2, 3) and (4, -1) is",
    options: ["A. x + 2y = 8", "B. 2x + y = 7", "C. 2x + y = 8", "D. x - 2y = 1"],
    answer: "B"
  },
  {
    id: 8,
    question: "The midpoint of the line joining the points (3, -5) and (7, 1) is",
    options: ["A. (4, 6)", "B. (2, 5)", "C. (-2, 5)", "D. (5, -2)"],	
    answer: "D"
  },
  {
    id: 9,
    question: "The point of intersection of the lines 2x + 3y = 8 and 2x - 3y = -4 is",
    options: ["A. (-1, 2)", "B. (2, 1)", "C. (1, 2)", "D. (1, -2)"],
    answer: "C"
  },
  {
    id: 10,
    question: "The centre of the circle (x - 4)² + (y + 2)² = 25 is",
    options: ["A. (4, 2)", "B. (-4, 2)", "C. (4, -2)", "D. (-4, -2)"],
    answer: "C"
  },
{
  id: 11,
  question: "The equation of the parabola symmetric about the x-axis, with vertex at the origin, and passing through the point (3, 6) is",
  options: [
    "A. y² = 12x",
    "B. y² = -12x",
    "C. x² = 12y",
    "D. y² = 6x"
  ],
  answer: "A"
},
  {
    id: 12,
    question: `Match the postulates in List-I with the expressions in List-II.
      List-I: (a) Associative law  (b) Distributive law  (c) De Morgan's law  (d) Absorption law
      List-II: (i) A+(BC) = (A+B)(A+C)  (ii) A+(AB) = A  (iii) (A+B)' = A'B'  (iv) A+(B+C) = (A+B)+C`,
    options: ["A. a-iv, b-i, c-iii, d-ii", "B. a-i, b-ii, c-iii, d-iv", "C. a-iv, b-iii, c-i, d-ii", "D. a-ii, b-i, c-iv, d-iii"],
    answer: "A"
  },
  {
    id: 13,
    question: "The sum of the binary numbers 1101.11 and 1011.01 is",
    options: ["A. 11001.10", "B. 11000.00", "C. 11001.00", "D. 11000.10"],
    answer: "C"
  },
  {
    id: 14,
    question: "The Boolean function XY + X'Z is equivalent to",
    options: ["A. X'Y'Z + XYZ' + X'YZ", "B. XY + X'Z + YZ", "C. XYZ + X'YZ + Y'Z'", "D. XYZ + XYZ' + XY'Z"],
    answer: "B"
  },
  {
    id: 15,
    question: "The Boolean expression (A+B)' = A'B' and (AB)' = A'+B' together represent",
    options: ["A. De Morgan's law", "B. Distributive law", "C. Absorption law", "D. Idempotent law"],
    answer: "A"
  },
  {
    id: 16,
    question: `Match List-I with List-II.
      List-I: (a) cos(π/3)  (b) cos(π/4)  (c) cos(π/6)  (d) cos(π/2)
      List-II: (i) √3/2  (ii) 1/√2  (iii) 1/2  (iv) 0`,
    options: ["A. a-iv, b-ii, c-i, d-iii", "B. a-iii, b-ii, c-i, d-iv", "C. a-iii, b-i, c-ii, d-iv", "D. a-i, b-ii, c-iii, d-iv"],
    answer: "B"
  },
  {
    id: 17,
    question: "The general solution of 2sinθ - 1 = 0 is",
    options: ["A. θ = nπ + (-1)ⁿ π/3, n ∈ I", "B. θ = 2nπ ± π/6, n ∈ I", "C. θ = 2nπ ± π/3, n ∈ I", "D. θ = nπ + (-1)ⁿ π/6, n ∈ I"],
    answer: "D"
  },
{
  id: 18,
  question: "In a right-angled isosceles triangle ABC, right angle at B, if side b = 4, then sides a and c are respectively",
  options: [
    "A. 2, 2",
    "B. 4, 4",
    "C. 2√2, 2√2",
    "D. 8, 4"
  ],
  answer: "C"
},
  {
    id: 19,
    question: "tan⁻¹(1) + tan⁻¹(1/2) + tan⁻¹(1/3) =",
    options: ["A. π", "B. π/4", "C. π/2", "D. 3π/4"],
    answer: "C"
  },
{
  id: 20,
  question: "Two dice are thrown and the sum of the numbers is noted. Among the events A: sum is odd, B: sum is a multiple of 4, C: sum is less than 5, D: sum is greater than 10, which pair is mutually exclusive?",
  options: [
    "A. B and C",
    "B. A and C",
    "C. B and D",
    "D. A and B"
  ],
  answer: "D"
},
  {
    id: 21,
    question: "Two students 'P' and 'Q' appeared for an exam. The probability that 'P' will qualify is 0.08 and that 'Q' will qualify is 0.12. The probability that both 'P' and 'Q' will qualify is 0.03. Find the probability that neither 'P' nor 'Q' will qualify.",
    options: ["A. 0.17", "B. 0.97", "C. 0.83", "D. 0.20"],
    answer: "C"
  },
  {
    id: 22,
    question: "The probability of selecting a woman from a crowd containing 15 men and 25 women is",
    options: ["A. 15/40", "B. 25/40", "C. 15/25", "D. 25/15"],
    answer: "B"
  },
  {
    id: 23,
    question: "Four cards are drawn successively without replacement from a pack of 52 well-shuffled cards. What is the probability that all four cards drawn are aces?",
    options: ["A. 4/52", "B. 1/270725", "C. 1/13", "D. 4/2652"],
    answer: "B"
  },
  {
    id: 24,
    question: "A man is known to speak truth 4 out of 5 times. He throws a die and reports that it is a five. Find the probability that it is actually five.",
    options: ["A. 4/5", "B. 1/9", "C. 4/9", "D. 1/5"],
    answer: "C"
  },
  {
    id: 25,
    question: "The variance of 20 observations is 8. If each observation is multiplied by 2, then the new variance of the resulting observations is",
    options: ["A. 8", "B. 16", "C. 64", "D. 32"],
    answer: "D"
  },
{
    id: 26,
    question: "A committee of two persons is selected from three men and two women. What is the probability that the committee will have one man and one woman?",
    options: ["A. 1/5", "B. 2/5", "C. 1/2", "D. 3/5"],
    answer: "D"
  },
  {
    id: 27,
    question: "If the roots of the quadratic equation x² - 6x + k = 0 are equal, then the value of k is",
    options: ["A. 9", "B. 6", "C. 3", "D. 12"],
    answer: "A"
  },
{
  id: 28,
  question: "If a, b, c are in Arithmetic Progression, then 1/bc, 1/ca, 1/ab are in",
  options: [
    "A. Harmonic Progression",
    "B. Geometric Progression",
    "C. Arithmetic Progression",
    "D. None of the above"
  ],
  answer: "C"
},
  {
    id: 29,
    question: "The equation of the ellipse with major axis along the x-axis, centre at origin, passing through (4, 0) and (0, 3) is",
    options: ["A. 9x² + 16y² = 1", "B. x²/9 + y²/16 = 1", "C. x²/16 + y²/9 = 1", "D. x²/16 - y²/9 = 1"],
    answer: "C"
  },
  {
    id: 30,
    question: "The distance between the foci of the hyperbola x²/9 - y²/16 = 1 is",
    options: ["A. 10", "B. 5", "C. 8", "D. 6"],
    answer: "A"
  }
];
 
export default pgcetmcaMathematics;